var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageHolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3333 35.4167C31.2658 35.4167 33.6458 33.0367 33.6458 30.1042C33.6458 27.1717 31.2658 24.7917 28.3333 24.7917C25.4008 24.7917 23.0208 27.1717 23.0208 30.1042C23.0208 33.0367 25.4008 35.4167 28.3333 35.4167ZM21.25 17.7083H63.75C65.705 17.7083 67.2917 19.295 67.2917 21.25V50.8725L55.9477 41.1967C52.4415 38.2146 46.9554 38.2146 43.481 41.1754L17.7083 62.6804V21.25C17.7083 19.295 19.295 17.7083 21.25 17.7083ZM63.75 10.625H21.25C15.3921 10.625 10.625 15.3921 10.625 21.25V63.75C10.625 69.6079 15.3921 74.375 21.25 74.375H63.75C69.6079 74.375 74.375 69.6079 74.375 63.75V21.25C74.375 15.3921 69.6079 10.625 63.75 10.625Z",
    fill: "#464A4D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 65,
    height: 65
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3333 35.4167C31.2658 35.4167 33.6458 33.0367 33.6458 30.1042C33.6458 27.1717 31.2658 24.7917 28.3333 24.7917C25.4008 24.7917 23.0208 27.1717 23.0208 30.1042C23.0208 33.0367 25.4008 35.4167 28.3333 35.4167ZM21.25 17.7083H63.75C65.705 17.7083 67.2917 19.295 67.2917 21.25V50.8725L55.9477 41.1967C52.4415 38.2146 46.9554 38.2146 43.481 41.1754L17.7083 62.6804V21.25C17.7083 19.295 19.295 17.7083 21.25 17.7083ZM63.75 10.625H21.25C15.3921 10.625 10.625 15.3921 10.625 21.25V63.75C10.625 69.6079 15.3921 74.375 21.25 74.375H63.75C69.6079 74.375 74.375 69.6079 74.375 63.75V21.25C74.375 15.3921 69.6079 10.625 63.75 10.625Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageHolder);
export default __webpack_public_path__ + "static/media/image-holder.354da01f.svg";
export { ForwardRef as ReactComponent };